import React from 'react';

/**
 * DPS Pune East — Hiring lockup.
 *
 * The design system's primary logo is "shield + wordmark", but the horizontal
 * wordmark PNG could not be imported from the Claude Design project (every
 * version exceeds the design API's binary read cap). So, as on the EOI landing
 * page, this pairs the real crest with the school name set in Titillium Web.
 * That is deliberately NOT a substitute wordmark — swap in the real asset when
 * it arrives. See the design system's assets README.
 *
 * "Hiring" is the module name and rides under the school name.
 *
 * size="full"    — auth pages, on the light wash
 * size="compact" — sidebar, on the dark brand-black panel
 * size="icon"    — crest alone, for tight spaces
 */
export default function DPSLogo({ size = 'full', className = '', school = 'DPS Pune East' }) {
  const crest = `${process.env.PUBLIC_URL}/assets/dps-crest.png`;
  // The signed-in school's name. Kept to a single truncated line so a longer
  // name (e.g. Hinjawadi) can never wrap and shift everything below it in the
  // sidebar. Falls back to the default on auth pages, where no school is set.
  const schoolName = (school && String(school).trim()) || 'DPS Pune East';

  if (size === 'icon') {
    return (
      <img
        src={crest}
        alt="Delhi Public School Pune East"
        className={`h-10 w-auto shrink-0 ${className}`}
      />
    );
  }

  if (size === 'compact') {
    // On the dark sidebar: white school name, orange module label.
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        <img src={crest} alt="" aria-hidden="true" className="h-10 w-auto shrink-0" />
        <div className="leading-tight min-w-0">
          <div className="font-heading font-bold text-[17px] leading-tight tracking-tight text-white truncate" title={schoolName}>
            {schoolName}
          </div>
          <div className="text-[11px] uppercase tracking-label font-semibold text-dps-orange mt-0.5">
            Hiring
          </div>
        </div>
        <span className="sr-only">{schoolName} — Hiring</span>
      </div>
    );
  }

  // full — login / register / forgot-password
  return (
    <div className={`flex flex-col items-center gap-2 ${className}`}>
      <img
        src={crest}
        alt=""
        aria-hidden="true"
        className="h-14 w-auto"
      />
      <div className="text-center">
        <div className="font-heading font-bold text-[28px] leading-tight tracking-tight text-dps-ink">
          {schoolName}
        </div>
        <div className="text-[11px] uppercase tracking-label font-semibold text-dps-orange mt-1">
          Hiring
        </div>
      </div>
      <span className="sr-only">{schoolName} — Hiring</span>
    </div>
  );
}
